import React from 'react';
import { MonthPanelSC } from './month-panel.styled';
import { CalendarMonth, PropsGetterConfig } from '@rehookify/datepicker';
import { getMonthClassName } from '../../date-time.utils';
import { TPropsGetters } from '../../date-time.types';

interface MonthPanelProps {
  months: CalendarMonth[];
  monthButton: TPropsGetters['monthButton'];
  config?: PropsGetterConfig;
}

const MonthPanel: React.FunctionComponent<MonthPanelProps> = ({ months, monthButton, config }) => {
  return (
    <MonthPanelSC>
      {months.map((month) => (
        <button
          className={getMonthClassName(month)}
          key={month.name}
          {...monthButton(month, config)}
        >
          {month.name}
        </button>
      ))}
    </MonthPanelSC>
  );
};

export default MonthPanel;
